import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useSelector } from "react-redux";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
function NurseDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [blogDetails, setBlogDetails] = useState({});
  const pageSlice = useSelector((state) => state.pageSlice.pageSlice);
  const navigate = useNavigate();
  const { state } = useLocation();
  const activeTab = state?.activeTab;
  const fetchUserDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthProfessional/get-nurse/${id}`
      );
      setBlogDetails(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching user details:", error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUserDetails();
  }, [id]);

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleStatusChange = async (status) => {
    if (status === "approved") {
      setIsApproving(true);
    } else {
      setIsRejecting(true);
    }

    try {
      const response = await client.put(
        `/admin/profile/change-status/${id}`,
        null,
        {
          params: { status },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || `Request ${status} successfully`
        );
        fetchUserDetails();
        navigate(-1);
      } else {
        toast.error(response.data.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      toast.error(`Failed to ${status} request`);
    } finally {
      if (status === "approved") {
        setIsApproving(false);
      } else {
        setIsRejecting(false);
      }
    }
  };

  return (
    <>
      <div class="admin-dashboard">
        <Sidebar />
        <div class="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() =>
                    navigate(-1, { state: { activeTab: activeTab } })
                  }
                />
                <span>Requests</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div class="setting-main request-main">
                <div class="setting-details">
                  <div class="basic-detail">
                    <div class="profile-upload">
                      <div class="profile-img">
                        <img src={blogDetails?.information?.image} alt="" />
                      </div>
                    </div>
                    <div class="profile-details">
                      <div class="profile-head">
                        <div class="">
                          <h2>
                            {blogDetails?.user?.firstName}{" "}
                            {blogDetails?.user?.lastName}
                          </h2>
                          <p>
                            <span>Request ID:</span> {blogDetails?.profileId}
                          </p>
                        </div>
                        {pageSlice === "request" && activeTab === "Pending" && (
                          <div className="reject-approve-btn">
                            <button
                              className="reject-btn"
                              onClick={() => handleStatusChange("rejected")}
                              disabled={isRejecting || isApproving}
                            >
                              {isRejecting ? "Processing..." : "Reject"}
                            </button>
                            <button
                              className="approve-btn"
                              onClick={() => handleStatusChange("approved")}
                              disabled={isApproving || isRejecting}
                            >
                              {isApproving ? "Processing..." : "Approve"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div class="input-group">
                        <div class="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Henry"
                            value={formatRole(
                              blogDetails?.facilityOrProfession
                            )}
                          />
                        </div>
                        <div class="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(blogDetails?.role)}
                          />
                        </div>
                        <div class="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              blogDetails?.user?.phoneNumber?.number
                                ? `+${blogDetails?.user?.phoneNumber?.dialCode} ${blogDetails?.user?.phoneNumber?.number}`
                                : ""
                            }
                          />
                        </div>
                      </div>
                      <div class="input-group">
                        <div class="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={blogDetails?.user?.email}
                          />
                        </div>
                        <div class="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={blogDetails?.information?.address?.add}
                          />
                        </div>
                        <div class="input-field"></div>
                      </div>
                      <div class="input-group">
                        {blogDetails?.information?.additionalText && (
                          <div class="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={blogDetails?.information?.additionalText}
                            ></textarea>
                          </div>
                        )}
                        {blogDetails?.professionalDetails?.qualification && (
                          <div class="input-field" style={{ width: "48%" }}>
                            <label>Qualification</label>
                            <textarea
                              placeholder="Qualification"
                              value={
                                blogDetails?.professionalDetails?.qualification
                              }
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="request-document">
                <h3>Professional Documents</h3>
                <div class="doc-main">
                  <div>
                    <div class="doc">
                      <div
                        class="doc-file"
                        onClick={() =>
                          setSelectedImage(
                            blogDetails?.professionalDocuments?.certificate
                          )
                        }
                      >
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={blogDetails?.professionalDocuments?.certificate}
                          alt=""
                        />
                      </div>
                      <div class="Document-name">
                        <span>
                          {blogDetails?.professionalDocuments &&
                          Object.keys(blogDetails.professionalDocuments)
                            .length > 0
                            ? Object.keys(blogDetails.professionalDocuments)[0]
                            : "No document available"}
                        </span>
                      </div>
                    </div>
                    {blogDetails?.professionalDocuments?.license !== "" ? (
                      <div class="doc">
                        <div
                          class="doc-file"
                          onClick={() =>
                            setSelectedImage(
                              blogDetails?.professionalDocuments?.license
                            )
                          }
                        >
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={blogDetails?.professionalDocuments?.license}
                            alt=""
                          />
                        </div>
                        <div class="Document-name">
                          <span>
                            {blogDetails?.professionalDocuments &&
                            Object.keys(blogDetails.professionalDocuments)
                              .length > 0
                              ? Object.keys(
                                  blogDetails.professionalDocuments
                                )[1]
                              : "No document available"}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div class="request-document">
                <h3>Personal Documents</h3>
                <div class="doc-main">
                  <div>
                    <div class="doc">
                      <div
                        class="doc-file"
                        onClick={() =>
                          setSelectedImage(blogDetails?.personalDocuments?.nimc)
                        }
                      >
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={blogDetails?.personalDocuments?.nimc}
                          alt=""
                        />
                      </div>
                      <div class="Document-name">
                        <span>
                          {blogDetails?.personalDocuments &&
                          Object.keys(blogDetails.personalDocuments).length > 0
                            ? Object.keys(blogDetails.personalDocuments)[1]
                            : "No document available"}
                        </span>
                      </div>
                    </div>
                    {blogDetails?.personalDocuments?.license !== "" ? (
                      <div class="doc">
                        <div
                          class="doc-file"
                          onClick={() =>
                            setSelectedImage(
                              blogDetails?.personalDocuments?.license
                            )
                          }
                        >
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={blogDetails?.personalDocuments?.license}
                            alt=""
                          />
                        </div>
                        <div class="Document-name">
                          <span>
                            {blogDetails?.personalDocuments &&
                            Object.keys(blogDetails.personalDocuments).length >
                              0
                              ? Object.keys(blogDetails.personalDocuments)[0]
                              : "No document available"}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="doctors-details">
                <h3>Schedule</h3>
                <div className="doc-main doc-table-request">
                  <div className="doc">
                    {blogDetails?.serviceAndSchedule?.map((service, index) => (
                      <table key={index} className="schedule-table">
                        <thead>
                          <tr className="pb-3">
                            <td className="service-name" colSpan="2">
                              Service Name : {service.name}
                            </td>
                          </tr>
                          <tr>
                            <th className="col-time">Time</th>
                            <th className="col-days">Days Available</th>
                          </tr>
                        </thead>

                        <tbody>
                          {service.slots.map((slot, slotIndex) => (
                            <tr key={slotIndex}>
                              <td className="custom-td col-time">
                                {slot.startTime} - {slot.endTime}
                              </td>
                              <td className="custom-td col-days">
                                {slot.days.join(", ")}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ))}
                  </div>
                </div>
              </div>

              {/* <div class="doctors-details schedule-main">
                <h3>Schedule</h3>
                <div class="doc-main">
                  <div class="doc">
                    <div class="head">
                      <h4>Time</h4>
                    </div>
                    <ul>
                      <li>09:00 - 12:00</li>
                      <li>09:00 - 12:00</li>
                      <li>09:00 - 12:00</li>
                      <li>09:00 - 12:00</li>
                    </ul>
                  </div>
                  <div class="doc day">
                    <div class="head">
                      <h4>Days Available</h4>
                    </div>
                    <ul>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
}
export default NurseDetail;
